var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('team-grid',{attrs:{"userTeams":_vm.userTeams}})}
var staticRenderFns = []

export { render, staticRenderFns }